import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import { Quill } from 'react-quill';
var Embed = Quill["import"]('blots/embed');
/**
 * Overrides the Blot used by 'quill-mention' to get it's format closer to what we need in the html
 */

var CustomMentionBlot = /*#__PURE__*/function (_Embed) {
  _inheritsLoose(CustomMentionBlot, _Embed);

  function CustomMentionBlot(scroll, node) {
    return _Embed.call(this, scroll, node) || this;
  }

  CustomMentionBlot.create = function create(data) {
    var node = _Embed.create.call(this);

    if (typeof this.render === 'function') {
      node.appendChild(this.render(data));
    } else {
      node.innerText += data.name;
    }

    return CustomMentionBlot.setDataValues(node, data);
  };

  CustomMentionBlot.setDataValues = function setDataValues(element, data) {
    var domNode = element;
    domNode.dataset.id = data.id;
    domNode.dataset.name = data.name;
    return domNode;
  };

  CustomMentionBlot.value = function value(domNode) {
    return domNode.dataset;
  };

  return CustomMentionBlot;
}(Embed);

CustomMentionBlot.blotName = 'mention';
CustomMentionBlot.tagName = 'span';
CustomMentionBlot.className = 'mention';
export default CustomMentionBlot;
//# sourceMappingURL=custom-mention-blot.js.map